// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mT8J","badges":"styles_badges__3AGcr"};